import Vue from 'vue'
import VueRouter from 'vue-router'
// import Menu from './views/Menu.vue'

//user
import Login from './views/User/Login.vue'
import Registration from './views/User/Registration.vue'
import RecoverPassword from './views/User/RecoverPassword.vue'
import ResetPassword from './views/User/ResetPassword.vue'
import AccountActivation from './views/User/AccountActivation.vue'
import GooglePermissions from './views/GooglePermissions.vue'

import ListaItems from './views/ListaItems.vue'
import TableItems from './views/TableItems.vue'

import TableItemsGoogleAccessToken from './views/TableItemsGoogleAccessToken.vue'
import TableItemsScadenza from './views/TableItemsScadenza.vue'
import TableItemsPratiche from './views/TableItemsPratiche.vue'


import SchedaRole from './views/User/SchedaRole.vue'
import SchedaUser from './views/User/SchedaUser.vue'
import SchedaAnagrafica from './views/SchedaAnagrafica.vue'
import SchedaAttivita from './views/SchedaAttivita.vue'
import SchedaPratica from './views/SchedaPratica.vue'
import SchedaScadenza from './views/SchedaScadenza.vue'

import SchedaStudio from './views/SchedaStudio.vue'
import ListaStudi from './views/ListaStudi.vue'


import Error from './views/Error.vue'
import store from './store.js'
import TableItemsAttivita from "./views/TableItemsAttivita";
import ListaStudiSelectable from "./views/ListaStudiSelectable";

Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    { path: '/scheda_role', name: 'NewSchedaRole', component: SchedaRole, meta: { title: 'Scheda Ruolo', role: ['SuperAdmin'], header: 'close' } },
    { path: '/scheda_role/:id', name: 'SchedaRole', component: SchedaRole, meta: { title: 'Scheda Ruolo', role: ['SuperAdmin'], header: 'close' } },
    { path: '/scheda_user', name: 'NewSchedaUser', component: SchedaUser, meta: { title: 'Scheda Utente', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'], header: 'close' } },
    { path: '/scheda_user/:id', name: 'SchedaUser', component: SchedaUser, meta: { title: 'Scheda Utente', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'], header: 'close' } },
    { path: '/scheda_anagrafiche', name: 'NewSchedaAnagrafica', component: SchedaAnagrafica, meta: { title: 'Scheda Anagrafica', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'], header: 'close' } },
    { path: '/scheda_anagrafiche/:id', name: 'SchedaAnagrafica', component: SchedaAnagrafica, meta: { title: 'Scheda Anagrafica', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'], header: 'close' } },
    { path: '/scheda_attivita', name: 'NewSchedaAttivita', component: SchedaAttivita, meta: { title: 'Scheda Attivita', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'], header: 'close' } },
    { path: '/scheda_attivita/:id', name: 'SchedaAttivita', component: SchedaAttivita, meta: { title: 'Scheda Attivita', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'], header: 'close' } },
    { path: '/scheda_pratiche', name: 'NewSchedaPratica', component: SchedaPratica, meta: { title: 'Scheda Pratica', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'], header: 'close' } },
    { path: '/scheda_pratiche/:id', name: 'SchedaPratica', component: SchedaPratica, meta: { title: 'Scheda Pratica', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore','CollaboratoreEsterno'], header: 'close' } },
    { path: '/scheda_scadenze', name: 'NewSchedaScadenza', component: SchedaScadenza, meta: { title: 'Scheda Scadenza', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'], header: 'close' } },
    { path: '/scheda_scadenze/:id', name: 'SchedaScadenza', component: SchedaScadenza, meta: { title: 'Scheda Scadenza', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore','CollaboratoreEsterno'], header: 'close' } },

    { path: '/', component: Login, meta: { title: 'Login', role: ['Public'] } },
    { path: '/utente/login', component: Login, meta: { title: 'Login', role: ['Public'] } },
    { path: '/utente/recupera_password', component: RecoverPassword, meta: { title: 'Recupera Password', role: ['Public'] } },
    { path: '/utente/resetta_password', component: ResetPassword, meta: { title: 'Resetta Password', role: ['Public'] } },
    { path: '/utente/registrati', component: Registration, meta: { title: 'Registrati', role: ['Public'] } },
    { path: '/utente/attivazione', component: AccountActivation, meta: { title: 'Account Attivato', role: ['Public'] } },

    { path: '/error', component: Error, meta: { title: 'Errore', role: ['Public'] } },

    // { path: '/menu', component: Menu, meta: { title: 'Menu', role: ['Admin', 'Utente','Visualizzatore'] } },
    { path: '/google_permissions', component: GooglePermissions, meta: { title: 'Permessi Google', role: ['Admin', 'Utente','Visualizzatore'] } },
    //TODO role perchè può essere dinamico
    { path: '/lista/:id', component: ListaItems, meta: { title: 'Lista', role: ['Admin', 'Utente','Visualizzatore'] } },


    //Su table ci sono casi specifici
    // { path: '/table/ContatoriAttrezzature', component: TableItemsContatoriAttrezzature, meta: { title: 'Tabella', role:  ['SuperAdmin', 'Admin', 'Utente','Visualizzatore']} },
    //e il caso generale
    { path: '/table/GoogleAccessToken', component: TableItemsGoogleAccessToken, meta: { title: 'Google Access Tokens', role:  ['SuperAdmin', 'Admin']} },
    { path: '/table/Scadenza', component: TableItemsScadenza, meta: { title: 'Lista Scadenze', role:  ['SuperAdmin', 'Admin', 'Utente','Visualizzatore','CollaboratoreEsterno']} },
    { path: '/table/Pratica', component: TableItemsPratiche, meta: { title: 'Lista Pratiche', role:  ['SuperAdmin', 'Admin', 'Utente','Visualizzatore','CollaboratoreEsterno']} },
    { path: '/table/Attivita', component: TableItemsAttivita, meta: { title: 'Lista Attivita', role:  ['SuperAdmin', 'Admin', 'Utente','Visualizzatore']} },
    { path: '/menu', component: TableItemsScadenza, meta: { title: 'Lista Scadenze', role:  ['SuperAdmin', 'Admin', 'Utente','Visualizzatore','CollaboratoreEsterno']}  },

    { path: '/table/:id', component: TableItems, meta: { title: 'Tabella', role: ['SuperAdmin', 'Admin', 'Utente','Visualizzatore'] } },

    { path: '/lista_studi', component: ListaStudi, meta: { title: 'Lista Studi', role: ['SuperAdmin'] } },
    { path: '/lista_studi_selectable', component: ListaStudiSelectable, meta: { title: 'Lista Studi', role: ['SuperAdmin'] } },

    { path: '/scheda_studio', name: 'NewSchedaStudio', component: SchedaStudio, meta: { title: 'Scheda Studio', role: ['SuperAdmin'], header: 'close' } },
    { path: '/scheda_studio/:id', name: 'SchedaStudio', component: SchedaStudio, meta: { title: 'Scheda Studio', role: ['SuperAdmin'], header: 'close' } },

  ],
})



//se riconosco un back (sia tramite router.go(-1) o back del browser, tolgo dallo store le eventuali breadcumb
window.addEventListener('popstate', () => {
  store.commit('doublePopToModalNavigationBreadcumbs');
})



//global navigation guard
router.beforeEach(function (to, from, next) {
  (to, from, next)

  //raccolgo tutte le rotte con meta.header.close in uno stato vuex (per avere un breadcumbs di navigazione)
  if (to.meta.header === 'close') {
    store.commit('pushToModalNavigationBreadcumbs', to);
  }
  else {
    store.commit('resetModalNavigationBreadcumbs');
  }




  document.title = `${(to.meta.title || '')} - ${store.state.client_settings.APPNAME}`;

  const route_roles = to.meta.role;
  const user_role = store.state.token_obj.role || 'Public'
  //passa se la rotta è pubblica oppure il ruolo e la rotta corrispondono
  //nota bene, che essendo il ruolo modificabile clientside, bisogna sempre controverificare le risorse server side.
  if (route_roles.indexOf(user_role) != -1 || route_roles.indexOf('Public') != -1 || user_role == 'SuperAdmin') {
    next();
  }
  else {

    //se è loggato allora mostro il modal
    if (store.state.token_obj != null &&
      store.state.token_obj !== "") {
      store.commit('update_modal_dialog', { title: 'Attenzione', text: 'Non sei autorizzato a visualizzare questo contenuto <br> Se non sei loggato o devi cambiare ruolo <a href="/utente/login">Vai al Login</a>', visible: true });
    }
    else { //altrimenti vai al login


      next({
        path: '/utente/login',
        params: { nextUrl: to.fullPath }
      })
    }
  }

})
export default router;